import copy from 'copy-to-clipboard';
import React, { useState } from 'react';

import {
  Button,
  Icon,
  NewButton,
  Paragraph,
  Popover,
  PopoverContent,
  PopoverTrigger,
  VStack,
} from '@eluve/components';

interface IdItem {
  label: string;
  value: string | null | undefined;
}

export interface FileIdsPopoverProps {
  ids: IdItem[];
}

export const FileIdsPopover: React.FC<FileIdsPopoverProps> = ({ ids }) => {
  const [copiedId, setCopiedId] = useState<string | null>(null);

  const handleCopy = (value: string) => {
    copy(value);
    setCopiedId(value);
    setTimeout(() => setCopiedId(null), 2000);
  };

  const validIds = ids.filter((id) => id.value);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="icon">
          <Icon name="Copy" size="sm" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <VStack gap={2}>
          <Paragraph weight="medium" size="md">
            Copy IDs
          </Paragraph>
          {validIds.map((id) => (
            <div
              key={id.label}
              className="flex w-full items-center justify-between gap-2 rounded border p-2"
            >
              <div className="min-w-0 flex-1">
                <Paragraph size="sm">{id.label}</Paragraph>
                <p className="truncate text-sm" title={id.value!}>
                  {id.value}
                </p>
              </div>
              <NewButton
                type="ghost"
                icon={{ name: copiedId === id.value ? 'Check' : 'Copy' }}
                onClick={() => handleCopy(id.value!)}
              />
            </div>
          ))}
        </VStack>
      </PopoverContent>
    </Popover>
  );
};
